import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemForCatalogController.php
* @route '/api/item-catalog/{item}'
*/
const GetItemForCatalogController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemForCatalogController.url(args, options),
    method: 'get',
})

GetItemForCatalogController.definition = {
    methods: ["get","head"],
    url: '/api/item-catalog/{item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemForCatalogController.php
* @route '/api/item-catalog/{item}'
*/
GetItemForCatalogController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetItemForCatalogController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemForCatalogController.php
* @route '/api/item-catalog/{item}'
*/
GetItemForCatalogController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemForCatalogController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemForCatalogController::__invoke
* @see app/Http/Controllers/Item/GetItemForCatalogController.php
* @route '/api/item-catalog/{item}'
*/
GetItemForCatalogController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemForCatalogController.url(args, options),
    method: 'head',
})

export default GetItemForCatalogController